import { Check, X, ArrowUpRight } from "lucide-react";

const ROWS = (venue) => [
  {
    us: "8x Wedding Awards winners with over 400 five-star reviews",
    them: "A handful of reviews and no track record to check",
  },
  {
    us: "Story-led wedding films crafted to tell the unique story of your day",
    them: "A highlight montage with no story",
    link: { href: "/our-storytelling", label: "How we tell your story", track: "comparison-storytelling" },
  },
  {
    us: `A team of wedding professionals, 1000+ weddings captured, 30+ combined years in the industry. We've seen it all and know where to be at ${venue} to capture the best shots!`,
    them: "100 weddings and a few years in the industry",
  },
  {
    us: "Lifetime wedding guarantee. Your footage backed up onsite, on AWS, and offsite. Forever.",
    them: "Your wedding collection deleted a few weeks after you receive it",
    link: { href: "/lifetime-guarantee", label: "Our backup process (for the geeks)", track: "comparison-guarantee" },
  },
  {
    us: "The Wedding Video Essex App: planning tools, manage your booking, interest-free monthly payments, VIP supplier discounts and a 250+ point wedding checklist",
    them: "An email confirming your date",
  },
  {
    us: "A full team of experienced wedding professionals, in-house editing, and backup kit for the backup kit. Your memories are captured no matter what!",
    them: "A one man band. If they're ill the week of your wedding, you're stuffed",
  },
  {
    us: "Sneak peek highlight film within 72 hours of your wedding",
    them: "Months of silence before you see a single frame",
  },
  {
    us: "Two videographers on every single wedding as standard. Your reaction and theirs, both captured. While one films you walking down the aisle, the other is on your partner's face. You'll finally see the moments you couldn't",
    them: "One camera, one angle, missed moments",
  },
  {
    us: "Your vows, speeches and first dance recorded on dedicated audio kit. These are the words you'll want to hear again in 50 years. Every whisper, every crack in the voice, crystal clear, not lost under room echo and chatter",
    them: "Camera mic from the back of the room",
  },
  {
    us: "Watch 1000 full wedding films and full wedding albums before you book",
    them: "A 60 second montage of their best 10 seconds from 30 weddings",
  },
  {
    us: "We answer within 24 hours, always",
    them: "Three weeks of silence then \"sorry, just seen this\"",
  },
];

function RowLink({ link, slug }) {
  if (!link) return null;
  const href = slug ? `${link.href}?q=${slug}` : link.href;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid={`${link.track}-link`}
      data-track-click={link.track}
      className="inline-flex items-center gap-2 mt-3 bg-[#CCBA56] hover:bg-[#B5A244] text-[#1F1E1D] px-5 py-2.5 text-[11px] tracking-overline uppercase font-semibold transition-colors shadow-[0_4px_14px_rgba(204,186,86,0.35)]"
    >
      {link.label}
      <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={2} />
    </a>
  );
}

export function ComparisonSection({ venueName, slug }) {
  const venue = venueName || "your venue";
  return (
    <section
      data-testid="comparison-section"
      data-track-section="comparison"
      className="px-6 md:px-12 lg:px-16 py-24 md:py-32"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16 md:mb-20">
          <div className="text-[#A9927D] text-xs tracking-overline uppercase font-medium mb-5">
            Why couples choose us
          </div>
          <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-tight text-[#1F1E1D] mb-8">
            There's a reason we're not the cheapest.
          </h2>
          <p className="text-[#5C5A56] max-w-2xl mx-auto text-lg leading-relaxed">
            Since 2015 we've stood in every church, barn and wedding venue in Essex.
            We know where the golden hour hits at {venue}. We know which
            registrars talk fast. When your day throws a curveball, we've
            already seen it 50 times.
          </p>
        </div>

        {/* Column headers */}
        <div className="grid grid-cols-2 gap-6 md:gap-12 pb-4 border-b border-[#1F1E1D]/15">
          <div className="text-[#8A8782] text-sm md:text-base font-medium tracking-overline uppercase">
            The Others
          </div>
          <div className="text-[#1F1E1D] text-sm md:text-base font-medium tracking-overline uppercase">
            Wedding Video Essex
          </div>
        </div>

        <div className="divide-y divide-[#1F1E1D]/10">
          {ROWS(venue).map((r, i) => (
            <div
              key={i}
              className="grid grid-cols-2 gap-6 md:gap-12 py-6 md:py-8"
              data-testid={`comparison-row-${i}`}
            >
              <div className="flex items-start gap-4">
                <span className="mt-0.5 shrink-0 w-7 h-7 rounded-full bg-[#B3261E]/10 border border-[#B3261E]/40 flex items-center justify-center">
                  <X className="w-4 h-4 text-[#B3261E]" strokeWidth={3} />
                </span>
                <p className="text-[#8A8782] text-sm md:text-base leading-relaxed">
                  {r.them}
                </p>
              </div>
              <div className="flex items-start gap-4">
                <span className="mt-0.5 shrink-0 w-7 h-7 rounded-full bg-[#CCBA56] flex items-center justify-center shadow-[0_2px_8px_rgba(204,186,86,0.4)]">
                  <Check className="w-4 h-4 text-[#1F1E1D]" strokeWidth={3.5} />
                </span>
                <div>
                  <p className="text-[#1F1E1D] text-sm md:text-base leading-relaxed">
                    {r.us}
                  </p>
                  <RowLink link={r.link} slug={slug} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
